import pkg from '../../package.json' with { type: 'json' };

/** SDK version. Sourced from package.json so the User-Agent stays in sync with the published version. */
export const SDK_VERSION: string = pkg.version;
